import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link, withRouter} from 'react-router-dom';
import Popup from 'reactjs-popup';
import DatePicker from 'react-datepicker';
import moment from 'moment-timezone';
import 'react-datepicker/dist/react-datepicker.css';
import {fetchTournamentPrintKitRequestPost} from '../../../../actions/tournamentPrintKitRequest.actions';

import './printKitRequest.scss';
import {
  Button,
  ButtonGroup,
  PageContainer,
  PageDescription,
  PageSubTitle,
  PageTitle,
  StepBox,
  Table,
} from '../../../Common/PageComponents';

moment.locale('ko_KR');

const stateToProps = state => {
  return {
    user: state.user,
    agreement: state.agreement,
  };
};

class PrintKitRequest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: moment(),
      posterCount: {
        poster1: 0,
        poster2: 0,
      },
      tournamentRound: '4강',
    };
    this._handleDateChange = this._handleDateChange.bind(this);
  }

  componentDidMount() {
    if (!this.props.agreement.printKit) {
      alert('리그 오브 레전드 프린트 키트 운영 정책에 동의하여야 합니다.');
      this.props.history.push('/news/tournament-kit/print-kit-request/agreement');
    }
  }

  _handleDateChange(date) {
    this.setState({
      startDate: date,
    });
  }

  _increasePosterCount(posterName, e) {
    e.preventDefault();

    let posterCount = this.state.posterCount;
    if (posterCount.poster1 + posterCount.poster2 >= 3) {
      alert('수량은 총 3개까지 신청 가능합니다.');
      return;
    }

    this.setState({
      posterCount: {
        ...posterCount,
        [posterName]: posterCount[posterName] + 1,
      },
    });
  }

  _decreasePosterCount(posterName, e) {
    e.preventDefault();

    let posterCount = this.state.posterCount;
    if (posterCount[posterName] === 0) {
      return;
    }

    this.setState({
      posterCount: {
        ...posterCount,
        [posterName]: posterCount[posterName] - 1,
      },
    });
  }

  _sendRequest(e) {
    e.preventDefault();

    let user = this.props.user;

    let tournamentPrintKitRequest = {
      userName: user.username,
      pcBangName: user.pcBangName,
      address: user.address,
      phone: `${this.form.tel1.value}-${this.form.tel2.value}-${this.form.tel3.value}`,
      tournamentRound: this.state.tournamentRound,
      tournamentDate: this.state.startDate.format('YYYY-MM-DD'),
      description: this.form.strDesc.value,
      posterRequestCounts: this.state.posterCount,
    };

    if (!this._validatePhoneNumber() || !this._validateDescription() || !this._validatePosterCount()) {
      return;
    }

    this.props.dispatch(fetchTournamentPrintKitRequestPost(tournamentPrintKitRequest, this.props.history));
  }

  _validatePhoneNumber() {
    if (this.form.tel1.value && this.form.tel2.value && this.form.tel3.value) {
      return true;
    }
    alert('연락처를 입력해주세요.');
    this.form.tel1.focus();
    return false;
  }

  _validateDescription() {
    if (this.form.strDesc.value) {
      return true;
    }
    alert('대회소개를 입력해주세요.');
    this.form.strDesc.focus();
    return false;
  }

  _validatePosterCount() {
    if (this.state.posterCount.poster1 > 0 || this.state.posterCount.poster2 > 0) {
      return true;
    }
    alert('포스터 필요 수량을 입력해주세요.');
    this.form.nPosterCnt01.focus();
    return false;
  }

  _filterNumeric(e) {
    if (e.charCode < 48 || e.charCode > 57) {
      e.preventDefault();
    }
  }

  _onTournamentRoundChange(e) {
    this.setState({
      tournamentRound: e.target.value,
    });
  }

  render() {
    let user = this.props.user;

    return (
      <PageContainer>
        <PageTitle title="토너먼트 키트" />
        <PageSubTitle title="프린트 키트 신청" />
        <StepBox activeIndex={1} steps={['이용약관동의', '신청서작성', '신청완료']} />
        <PageDescription>제공을 위해 아래 신청정보를 입력해주세요.</PageDescription>
        <form
          method="post"
          name="input_f"
          target="hiddenfrm"
          action="tournament_kit_poster2_proc.asp"
          autoComplete="off"
          ref={form => (this.form = form)}
        >
          <Table theme="form">
            <colgroup>
              <col width="200" />
              <col width="*" />
            </colgroup>
            <tbody>
              <tr>
                <th>PC방명</th>
                <td>{user.pcBangName}</td>
              </tr>
              <tr>
                <th>주소</th>
                <td>{user.address}</td>
              </tr>
              <tr>
                <th>연락처</th>
                <td>
                  <select style={{width: '52px'}} name="tel1" defaultValue="010">
                    <option value="010">010</option>
                    <option value="011">011</option>
                    <option value="016">016</option>
                    <option value="017">017</option>
                    <option value="018">018</option>
                    <option value="019">019</option>
                  </select>
                  &nbsp;-&nbsp;
                  <input
                    type="text"
                    className="input_text"
                    maxLength="4"
                    name="tel2"
                    id="tel2"
                    onKeyPress={e => this._filterNumeric(e)}
                    style={{width: '42px'}}
                    autoComplete="off"
                  />
                  &nbsp;-&nbsp;
                  <input
                    type="text"
                    className="input_text"
                    maxLength="4"
                    name="tel3"
                    id="tel3"
                    onKeyPress={e => this._filterNumeric(e)}
                    style={{width: '42px'}}
                    autoComplete="off"
                  />
                </td>
              </tr>
              <tr>
                <th>대회일시</th>
                <td>
                  <DatePicker selected={this.state.startDate} onChange={this._handleDateChange} />
                </td>
              </tr>
              <tr>
                <th>대회소개</th>
                <td>
                  <div className="txt">토너먼트 소개를 간단히 입력해 주세요.</div>
                  <textarea
                    cols="70"
                    rows="5"
                    id="strDesc"
                    name="strDesc"
                    style={{resize: 'none'}}
                    placeholder="(예시) 중간고사 이후 학생들에게 즐거움을 주기 위함. 상품은 우승 15시간 PC방 이용권, 준우승 10시간 PC방 이용권..."
                  />
                </td>
              </tr>
              <tr>
                <th>대회규모</th>
                <td>
                  <label htmlFor="4th">
                    <input
                      type="radio"
                      value="4강"
                      id="4th"
                      name="nScale"
                      onChange={e => this._onTournamentRoundChange(e)}
                      defaultChecked
                    />
                    4강
                  </label>
                  <label htmlFor="8th">
                    <input
                      type="radio"
                      value="8강"
                      id="8th"
                      name="nScale"
                      onChange={e => this._onTournamentRoundChange(e)}
                    />
                    8강
                  </label>
                  <label htmlFor="8th_consolation_round">
                    <input
                      type="radio"
                      value="8강_패자부활전"
                      id="8th_consolation_round"
                      name="nScale"
                      onChange={e => this._onTournamentRoundChange(e)}
                    />
                    8강 패자부활전
                  </label>
                </td>
              </tr>
              <tr>
                <th>포스터 이미지 선택</th>
                <td>
                  <div className="txt">수량은 총 3개 까지 선택 가능합니다.</div>
                  <ul className="poster-box">
                    <li>{this.renderNumberInput('poster1', this.state.posterCount.poster1)}</li>
                    <li>{this.renderNumberInput('poster2', this.state.posterCount.poster2)}</li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </Table>
        </form>
        <ButtonGroup>
          <Button onClick={e => this._sendRequest(e)}>작성완료</Button>
          <Link to="/news/tournament-kit">
            <Button theme="gray">취소</Button>
          </Link>
        </ButtonGroup>
        <div className="info_guide">
          본 양식에 PC방명, 사업자등록번호, 주소, 대표자명, 연락처를 기재하여 제출하는 것은 라이엇 게임즈 코리아 및 본
          행사를 진행하는 ㈜손오공 IB에 제공될 수 있습니다.
          <br />
          따라서 라이엇 게임즈 코리아 및 ㈜손오공 IB에 정보제공을 원하지 않으신다면, 본 토너먼트 키트의 신청을 삼가
          주시기를 부탁 드립니다.
          <br />
          등록하신 개인정보는 본 토너먼트 키트의 제공을 위해서만 사용되며, 토너먼트 키트 제공 등 목적을 다한 이후 복구할
          수 없는 방법을 통해 삭제됩니다.
          <br />
        </div>
      </PageContainer>
    );
  }

  renderNumberInput(id, value) {
    return (
      <dl>
        <dt>
          <Popup
            modal
            closeOnDocumentClick
            contentStyle={{padding: 0, width: '430px'}}
            trigger={<img src={`/image/customer/kit/${id}_s_2019.jpg`} alt="" />}
          >
            <img src={`/image/customer/kit/down_${id}_2019.jpg`} alt="" />
          </Popup>
        </dt>
        <dd>
          <div>{id.toUpperCase()}</div>
          <div className="num">
            <div className="num__title">수량선택</div>
            <div className="num__input">
              <input type="text" value={value} readOnly />
              <div className="num__arrow">
                <span onClick={e => this._increasePosterCount(id, e)}>&#9650;</span>
                <span onClick={e => this._decreasePosterCount(id, e)}>&#9660;</span>
              </div>
            </div>
          </div>
        </dd>
      </dl>
    );
  }
}

export default withRouter(connect(stateToProps)(PrintKitRequest));
